import React, { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import IndiaMap from "./IndiaMap";
import BorrowingMap from "./BorrowingMap";
import KPICard from "./KPICard";
import RightSidebar from "./RightSidebar";
import "./Dashboard123.css";
import Header from "./Header";
import DBTMap from "./DBTMap";
import DocMap from "./DocMap";
import DBTPieChart from "./DBTPieChart";
export default function Dashboard() {
  const [geo, setGeo] = useState(null);

  // Awareness + Abha
  const [metrics, setMetrics] = useState(null);
  const [abhaMetrics, setAbhaMetrics] = useState(null);

  // Borrowing
  const [borrowingKPI, setBorrowingKPI] = useState(null); // from Borrwing patt
  const [borrowingFinal, setBorrowingFinal] = useState(null); // from Borrowing_final

  // UI states
  const [selectedMetric, setSelectedMetric] = useState("heard");
  const [selectedAbhaMetric, setSelectedAbhaMetric] = useState("heard");
  const [selectedBorrowingMetric, setSelectedBorrowingMetric] = useState("borrowed_yes");
  const [selectedBorrowingSource, setSelectedBorrowingSource] = useState("All");
  const [activeTab, setActiveTab] = useState("awareness");
  const [hoveredPurposeData, setHoveredPurposeData] = useState(null);
// --- state variables ---
const [dbtMetrics, setDbtMetrics] = useState(null);
const [selectedDbtMetric, setSelectedDbtMetric] = useState("yes");
const [selectedDbtAgeGroup, setSelectedDbtAgeGroup] = useState("All");
// --- state variables ---
const [docMetrics, setDocMetrics] = useState(null);
const [selectedDocMetric, setSelectedDocMetric] = useState("Digital");
const [hoveredDbtPhoneData, setHoveredDbtPhoneData] = useState(null);


  useEffect(() => {
    // Load India GeoJSON
    fetch("/data/india.json").then(r => r.json()).then(setGeo);

    // Load Excel
    fetch("/data/SOW (2).xlsx")
      .then(res => res.arrayBuffer())
      .then(ab => {
        const wb = XLSX.read(ab, { type: "array" });

        const normalize = (s) => ({ "Tamilnadu": "Tamil Nadu" }[s] || s);

        // Awareness sheet
        const sheet1 = wb.Sheets["Awareness Of Social Assistance "];
        const rows1 = XLSX.utils.sheet_to_json(sheet1, { defval: null });
        const awareness = {};
        for (const r of rows1) {
          const state = normalize(r["State"]);
          const cat = r["Awareness Of Social Assistance Schemes"];
          const val = r["Total"];
          if (!state) continue;
          awareness[state] ||= { heard: null, availing: null, not_aware: null };
          if (cat === "Heard about the scheme") awareness[state].heard = val;
          if (cat === "I am availing it") awareness[state].availing = val;
          if (cat === "Not aware") awareness[state].not_aware = val;
        }

        // ABHA sheet
       // ABHA sheet
const sheet2 = wb.Sheets["Abha.digitalhealth"];
const rows2 = XLSX.utils.sheet_to_json(sheet2, { header: 1, defval: null });

const abha = {};
for (let i = 1; i < rows2.length; i++) {  // skip header row
  const row = rows2[i];
  if (!row || row.length < 4) continue;

  const state = normalize(row[0]);
  const awareness = row[1];
  const status = row[2];
  const valStr = row[3];

  if (!state || !awareness || !valStr) continue;

  // Convert % string → number
  let val = 0;
  if (typeof valStr === "string" && valStr.includes("%")) {
    val = parseFloat(valStr.replace("%", "").trim()) / 100;
  } else if (typeof valStr === "number") {
    val = valStr > 1 ? valStr / 100 : valStr;
  }

  abha[state] ||= { heard: 0, availing: 0, not_aware: 0 };

  if (awareness === "Heard about the scheme") {
    abha[state].heard += val;
  } else if (awareness === "I am availing it") {
    abha[state].availing += val;
  } else if (awareness === "Not aware") {
    abha[state].not_aware += val;
  }
}

setAbhaMetrics(abha);


        // Borrowing KPI (Borrwing patt)
        const sheet3 = wb.Sheets["Borrwing patt"];
        let borrowing = {};
        if (sheet3) {
          const rows3 = XLSX.utils.sheet_to_json(sheet3, { defval: null });
          for (const raw of rows3) {
            const r = {};
            Object.keys(raw).forEach(k => { r[k.trim()] = raw[k]; });
            const state = normalize(r["State"]);
            if (!state) continue;
            const borrowed = r["Borrowed Money"];
            const source = r["Source Of Borrowing"];
            const purpose = r["Purpose Of Loan Status"];
            const valStr = r["Total"];
            let val = 0;
            if (typeof valStr === "string" && valStr.includes("%")) {
              val = parseFloat(valStr.replace("%", "").trim()) / 100;
            } else if (typeof valStr === "number") {
              val = valStr > 1 ? valStr / 100 : valStr;
            }
            borrowing[state] ||= { borrowed_yes: 0, borrowed_no: 0, sources: {}, purposes: {} };
            if (borrowed === "Yes") {
              borrowing[state].borrowed_yes += val || 0;
              if (source) {
                borrowing[state].sources[source] = (borrowing[state].sources[source] || 0) + (val || 0);
              }
              if (purpose) {
                borrowing[state].purposes[purpose] = (borrowing[state].purposes[purpose] || 0) + (val || 0);
              }
            } else if (borrowed === "No") {
              borrowing[state].borrowed_no += val || 0;
            }
          }
        }

        // Borrowing Final (map + charts)
const sheet4 = wb.Sheets["Borrowing_final"]; // <-- check exact sheet name
let borrowingFinalData = {};
if (sheet4) {
  const rows4 = XLSX.utils.sheet_to_json(sheet4, { defval: null });

  console.log("🔎 Raw Borrowing_final rows:", rows4);

  for (const [i, raw] of rows4.entries()) {
    const r = {};
    Object.keys(raw).forEach(k => { r[k.trim()] = raw[k]; });

    const state = normalize(r["State"]);
    const source = r["Source Of Borrowing"];
    const purpose = r["Purpose Of Loan Status"];
    const valStr = r["Total"];

    console.log(
      `Row ${i}:`,
      { state, source, purpose, valStr, raw }
    );

    // Convert % string to decimal
    let val = 0;
    if (typeof valStr === "string" && valStr.includes("%")) {
      val = parseFloat(valStr.replace("%", "").trim()) / 100;
    } else if (typeof valStr === "number") {
      val = valStr > 1 ? valStr / 100 : valStr;
    }

    console.log(`   → Parsed value: ${val}`);

    if (!state) {
      console.warn(`⚠️ Skipping row ${i}, no state found`, raw);
      continue;
    }

    borrowingFinalData[state] ||= { borrowed_yes: 0, sources: {}, purposes: {} };

    // All rows here are "borrowed_yes"
    borrowingFinalData[state].borrowed_yes += val || 0;

    if (source) {
      borrowingFinalData[state].sources[source] =
        (borrowingFinalData[state].sources[source] || 0) + (val || 0);
    }

    if (purpose) {
      borrowingFinalData[state].purposes[purpose] =
        (borrowingFinalData[state].purposes[purpose] || 0) + (val || 0);
    }

    console.log(
      `   ✅ Updated ${state}:`,
      borrowingFinalData[state]
    );
  }
}
// DBT sheet
 // --- DBT Sheet ---
 const sheet5 = wb.Sheets["phone vs dbt"];
if (sheet5) {
  const rows5 = XLSX.utils.sheet_to_json(sheet5, { defval: "" });
  const dbt = {};

  const normalizeState = (s) => ({ "Tamilnadu": "Tamil Nadu" }[s] || s);

  rows5.forEach(r => {
    const state = normalizeState((r["State"] || "").trim());
    if (!state) return;
  
    const receiptRaw = (r["DBT Receipt From Government Scheme In Bank Account"] || "").trim();
    const gender = r["Gender"] || "Unknown";
    const ageGroup = r["Age"] || "Unknown";
    const valStr = r["Total"];
  
    let val = 0;
    if (typeof valStr === "string" && valStr.includes("%")) val = parseFloat(valStr.replace("%","").trim())/100;
    else if (typeof valStr === "number") val = valStr > 1 ? valStr/100 : valStr;
  
    const receipt = receiptRaw.toLowerCase();
    const receiptKey = (receipt === "yes" || receipt === "no") ? receipt : "blank";
  
    dbt[state] = dbt[state] || { yes: 0, no: 0, blank: 0, gender: {}, ageGroups: {} };
    dbt[state][receiptKey] += val;
  
    // Gender breakdown
    dbt[state].gender[gender] = (dbt[state].gender[gender] || 0) + val;
  
    // Age group breakdown
    dbt[state].ageGroups[ageGroup] = dbt[state].ageGroups[ageGroup] || { yes: 0, no: 0, blank: 0, gender: {} };
    dbt[state].ageGroups[ageGroup][receiptKey] += val;
    dbt[state].ageGroups[ageGroup].gender[gender] = (dbt[state].ageGroups[ageGroup].gender[gender] || 0) + val;
  
    // ✅ NEW: phone type breakdown
    const phoneType = r["Phone Type"] || "Unknown";
    dbt[state].phoneTypes = dbt[state].phoneTypes || {};
    dbt[state].phoneTypes[phoneType] =
      (dbt[state].phoneTypes[phoneType] || 0) + val;
  });
  

  setDbtMetrics(dbt);
}

 


// Document Handling sheet
// Document Handling sheet
const sheet6 = wb.Sheets["Doc_handeling"];
if (sheet6) {
  const rows6 = XLSX.utils.sheet_to_json(sheet6, { defval: null });
  const docs = {};
  for (const r of rows6) {
    const state = normalize(r["State"]);
    const method = r["Document Management Method"];
    const valStr = r["Total"];
    if (!state || !method) continue;

    let val = 0;
    if (typeof valStr === "string" && valStr.includes("%")) {
      val = parseFloat(valStr.replace("%", "").trim()) / 100;
    } else if (typeof valStr === "number") {
      val = valStr > 1 ? valStr / 100 : valStr;
    }

    docs[state] ||= {};
    docs[state][method] = (docs[state][method] || 0) + val;
  }

  setDocMetrics(docs);

  // ✅ Force initial selectedDocMetric to first available method
  const firstMethod = Object.keys(docs[Object.keys(docs)[0]] || {})[0];
  if (firstMethod) setSelectedDocMetric(firstMethod);
}

  








setMetrics(awareness);
setAbhaMetrics(abha);
setBorrowingKPI(borrowing);
setBorrowingFinal(borrowingFinalData);

console.log("Awareness parsed:", awareness);
console.log("ABHA parsed:", abha);
console.log("Borrowing KPI parsed:", borrowing);
console.log("📊 Borrowing Final parsed:", borrowingFinalData);
});
  }, []);

  if (!geo || !metrics || !abhaMetrics || !borrowingKPI || !borrowingFinal) {
    return <div>Loading dashboard…</div>;
  }

  // Awareness averages
  const values = Object.values(metrics);
  const avg = (key) => (values.reduce((sum, v) => sum + (v[key] || 0), 0) / values.length) * 100;

  // ABHA averages
  const abhaValues = Object.values(abhaMetrics);
  const abhaAvg = (key) => (abhaValues.reduce((sum, v) => sum + (v[key] || 0), 0) / abhaValues.length) * 100;

  // Borrowing averages (from KPI sheet only)
  const borrowingValues = Object.values(borrowingKPI);
  const borrowingAvg = (key) => (borrowingValues.reduce((sum, v) => sum + (v[key] || 0), 0) / borrowingValues.length) * 100;


  const dbtAvg = (key) => {
    if (!dbtMetrics) return 0;
  
    const states = Object.entries(dbtMetrics)
      .filter(([state, data]) => state && data);
  
    if (states.length === 0) return 0;
  
    const sum = states.reduce((acc, [_, data]) => {
      const v = parseFloat(data[key] || 0); // ensure numeric
      return acc + v;
    }, 0);
  
    return (sum / states.length) * 100;
  };
  
  
  
  let filteredDbtMetrics = {};
if (dbtMetrics) {
  Object.entries(dbtMetrics).forEach(([state, data]) => {
    if (!data) return;

    if (selectedDbtAgeGroup === "All") {
      filteredDbtMetrics[state] = {
        yes: data.yes,
        no: data.no,
        blank: data.blank,
        gender: data.gender,
        ageGroups: data.ageGroups,
        phoneTypes: data.phoneTypes    // ✅ include phone types
      };
    } else {
      const matchedAgeGroup = Object.keys(data.ageGroups || {}).find(
        key => key.replace(/\s/g,'') === selectedDbtAgeGroup.replace(/\s/g,'')
      );

      if (matchedAgeGroup) {
        const ageData = data.ageGroups[matchedAgeGroup];
        filteredDbtMetrics[state] = {
          yes: ageData.yes,
          no: ageData.no,
          blank: ageData.blank,
          gender: ageData.gender,
          ageGroups: { [matchedAgeGroup]: ageData },
          phoneTypes: data.phoneTypes   // ✅ still include phone types
        };
      }
    }
  });
}



console.log("✅ Final Filtered DBT Metrics:", filteredDbtMetrics);


  



  // Filter borrowing final data by source if selected
  const filteredBorrowingFinal = {};
  for (const [state, data] of Object.entries(borrowingFinal)) {
    if (selectedBorrowingSource === "All") {
      filteredBorrowingFinal[state] = data;
    } else if (data.sources[selectedBorrowingSource]) {
      filteredBorrowingFinal[state] = {
        borrowed_yes: data.sources[selectedBorrowingSource] || 0,
        sources: { [selectedBorrowingSource]: data.sources[selectedBorrowingSource] },
        purposes: data.purposes
      };
    }
  }

  // Collect unique sources
  const allSources = Array.from(new Set(Object.values(borrowingFinal).flatMap(d => Object.keys(d.sources))));

  return (
    <div className="dashboard-layout">
      

      {/* Tabs */}
      <div className="tabs">
  <button className={activeTab === "awareness" ? "active" : ""} onClick={() => setActiveTab("awareness")}>Awareness of Schemes</button>
  <button 
  className={activeTab === "doc" ? "active" : ""} 
  onClick={() => setActiveTab("doc")}
>
  Doc Handling Methods
</button>
<button className={activeTab === "dbt" ? "active" : ""} onClick={() => setActiveTab("dbt")}>DBT</button>
<button className={activeTab === "borrowing" ? "active" : ""} onClick={() => setActiveTab("borrowing")}>Borrowing Patterns</button>
  <button className={activeTab === "abha" ? "active" : ""} onClick={() => setActiveTab("abha")}>ABHA Digital Health Id</button>
  
  
  

</div>


      {/* Awareness Tab */}
      {activeTab === "awareness" && (
        <>
          <div className="kpi-row">
            <KPICard title="Heard" value={avg("heard")} color="#9333ea" />
            <KPICard title="Availing" value={avg("availing")} color="#6b21a8" />
            <KPICard title="Not Aware" value={avg("not_aware")} color="#a855f7" />
          </div>
          <div className="filter-row">
            <label htmlFor="metric-select">Select Metric: </label>
            <select id="metric-select" value={selectedMetric} onChange={(e) => setSelectedMetric(e.target.value)}>
              <option value="heard">Heard</option>
              <option value="availing">Availing</option>
              <option value="not_aware">Not Aware</option>
            </select>
          </div>
          <div className="main-content">
            <div className="map-wrapper">
              <IndiaMap geo={geo} metrics={metrics} metric={selectedMetric} />
            </div>
            <RightSidebar metrics={metrics} metric={selectedMetric} />
          </div>
        </>
      )}

      {/* ABHA Tab */}
      {activeTab === "abha" && (
        <>
          <div className="kpi-row">
            <KPICard title="Heard" value={abhaAvg("heard")} color="#16a34a" />
            <KPICard title="Availing" value={abhaAvg("availing")} color="#15803d" />
            <KPICard title="Not Aware" value={abhaAvg("not_aware")} color="#22c55e" />
          </div>
          <div className="filter-row">
            <label htmlFor="abha-metric-select">Select Metric: </label>
            <select id="abha-metric-select" value={selectedAbhaMetric} onChange={(e) => setSelectedAbhaMetric(e.target.value)}>
              <option value="heard">Heard</option>
              <option value="availing">Availing</option>
              <option value="not_aware">Not Aware</option>
            </select>
          </div>
          <div className="main-content">
            <div className="map-wrapper">
              <IndiaMap geo={geo} metrics={abhaMetrics} metric={selectedAbhaMetric} />
            </div>
            <RightSidebar metrics={abhaMetrics} metric={selectedAbhaMetric} />
          </div>
        </>
      )}

      {/* Borrowing Tab */}
      {activeTab === "borrowing" && (
        <>
          {/* KPI from Borrwing patt */}
          <div className="kpi-row">
            <KPICard title="Money Borrowed" value={borrowingAvg("borrowed_yes")} color="#16a34a" />
            <KPICard title="Money Not Borrowed" value={borrowingAvg("borrowed_no")} color="#dc2626" />
          </div>

          {/* Filters */}
          <div className="filter-row">
           

            <label htmlFor="borrowing-source-select">Source: </label>
            <select
              id="borrowing-source-select"
              value={selectedBorrowingSource}
              onChange={(e) => setSelectedBorrowingSource(e.target.value)}
            >
              <option value="All">All</option>
              {allSources.map((src) => (
                <option key={src} value={src}>{src}</option>
              ))}
            </select>
          </div>

          {/* Map + Sidebar */}
          <div className="main-content">
            <div className="map-wrapper">
            <BorrowingMap
  geo={geo}
  metrics={selectedBorrowingMetric === "borrowed_yes" ? filteredBorrowingFinal : {}}
  metric={selectedBorrowingMetric}
  onHoverPurpose={(purposes, state) => {
    if (purposes) {
      setHoveredPurposeData({ state, data: purposes });
    } else {
      setHoveredPurposeData(null);
    }
  }}
/>
            </div>
            <RightSidebar
  metrics={selectedBorrowingMetric === "borrowed_yes" ? filteredBorrowingFinal : {}}
  metric={selectedBorrowingMetric}
  hoveredPurposeData={hoveredPurposeData}
/>
          </div>
        </>
      )}

{/* DBT Tab */}
 {/* DBT Tab */}
 {/* DBT Tab */}
{activeTab === "dbt" && dbtMetrics && (
  <>
    <div className="kpi-row">
    <KPICard title="DBT Received (Yes)" value={dbtAvg("yes")} suffix="%" color="#2563eb" />
<KPICard title="DBT Not Received (No)" value={dbtAvg("no")} suffix="%" color="#dc2626" />
<KPICard title="Info not available" value={dbtAvg("blank")} suffix="%" color="#9ca3af" />

    </div>

    <div className="filter-row">
      <label htmlFor="dbt-metric-select">Select Metric: </label>
      <select id="dbt-metric-select" value={selectedDbtMetric} onChange={(e) => setSelectedDbtMetric(e.target.value)}>
        <option value="yes">Received (Yes)</option>
        <option value="no">Not Received (No)</option>
        <option value="blank">Blank/Unknown</option>
      </select>
      {/* Removed age group dropdown */}
    </div>

    <div className="main-content">
      <div className="map-wrapper">
      <DBTMap 
  geo={geo}
  metrics={filteredDbtMetrics}
  metric={selectedDbtMetric}
  onHoverPhoneTypes={(phoneTypes, state) => {
    if (phoneTypes) setHoveredDbtPhoneData({ state, data: phoneTypes });
    else setHoveredDbtPhoneData(null);
  }}
/>


      </div>
      <RightSidebar
    metrics={dbtMetrics}
    metric={selectedDbtMetric}
    hoveredDbtPhoneData={hoveredDbtPhoneData}  // ✅ pass here
  />

    </div>
   

  </>
)}


  {/* Doc Handling Tab */}
{activeTab === "doc" && docMetrics && (
  <>
    <div className="kpi-row">
      {Object.keys(docMetrics[Object.keys(docMetrics)[0]]).map((method) => (
        <KPICard 
          key={method} 
          title={method} 
          value={
            Object.values(docMetrics)
              .reduce((sum, v) => sum + (v[method] || 0), 0) /
            Object.keys(docMetrics).length * 100
          } 
          suffix="%" 
          color="#9333ea" 
        />
      ))}
    </div>

    <div className="filter-row">
      <label htmlFor="doc-metric-select">Select Method: </label>
      <select 
        id="doc-metric-select" 
        value={selectedDocMetric} 
        onChange={(e) => setSelectedDocMetric(e.target.value)}
      >
        {Object.keys(docMetrics[Object.keys(docMetrics)[0]]).map((method) => (
          <option key={method} value={method}>{method}</option>
        ))}
      </select>
    </div>

    <div className="main-content">
      <div className="map-wrapper">
      <DocMap geo={geo} metrics={docMetrics} metric={selectedDocMetric || Object.keys(docMetrics[Object.keys(docMetrics)[0]])[0]} />

      </div>
      <RightSidebar metrics={docMetrics} metric={selectedDocMetric} />
    </div>
  </>
)}

  {/* Footer note */}
  <div className="survey-note" style={{ 
      marginTop: "30px", 
      textAlign: "center", 
      fontSize: "16px", 
      fontStyle: "italic", 
      color: "#555", 
      marginBottom:"20px"
    }}>
      Note: The survey was conducted with a sample size of 3,500 respondents across 10 states.
    </div>
    </div>
    
  );
}
